import Layout from 'components/Layout';
import withGuard from 'components/withGuard';
import { PERMISSIONS } from 'constants/permissions';
import React from 'react';
import OrderForm from './Form';
import Steps from './Steps';

function CreateOrder() {
  return (
    <Layout header={(
      <Layout.Header
        title="New Order"
        backTitle="Orders"
        backPath="/console/orders"
      />
    )}
    >
      <Steps>
        <OrderForm />
      </Steps>
    </Layout>
  );
}
export default withGuard(CreateOrder, [PERMISSIONS.ORDERS], { redirect: true });
